"use strict";
/**
 * Polyfills for browser compatibility
 * This file contains polyfills that are needed for the clinic-telecom package to work properly
 */
// Polyfill for global object
// Required by Amazon Chime SDK
if (typeof window !== 'undefined' && !window.global) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.global = window;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicG9seWZpbGxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL3BvbHlmaWxscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7OztHQUdHO0FBRUgsNkJBQTZCO0FBQzdCLCtCQUErQjtBQUMvQixJQUFJLE9BQU8sTUFBTSxLQUFLLFdBQVcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxNQUFNLEVBQUUsQ0FBQztJQUNwRCw4REFBOEQ7SUFDN0QsTUFBYyxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7QUFDbEMsQ0FBQyJ9